export const withTimestamp = (url: string | undefined) => {
  return url ? `${url}?ts=${Date.now()}` : url;
};
